import client from "./client";

// TODO move to api/types
interface UpdateAssessmentValueInput {
    tags: string[];
    value: any;
    data?: any;
}

interface UpdateAssessmentDataInput {
    tags: string[];
    value?: any;
    data: any;
}

// NOTE: This type actually only requires the tags field due to the way
// types work in typescript. Requiring data XOR value is enforced through
// the methods that utilize it.
type UpdateAssessmentInput = UpdateAssessmentValueInput | UpdateAssessmentDataInput

export const initAssessment = async (sessionId: string, userId: string) => {
  const uri = `/assessment/wa/${sessionId}/${userId}/acd0be77-6d3f-415a-8317-d4d6ee95gdac`;
  return client.get(uri).then(response => response.data.response);
}

const updateAssessment = async (sessionId: string, userId: string, payload: UpdateAssessmentInput) => {
  const uri = `/assessment/${sessionId}/${userId}`;
  if (payload.data) { payload.data = JSON.stringify(payload.data); }

  return client.post(uri, payload).then(response => response.data.response);
}

export const updateAssessmentValue = async (sessionId: string, userId: string, tags: string[], value: any, data?: any) => {
  const payload: UpdateAssessmentValueInput = { tags, value, };
  if (data) { payload.data = data; }

  return updateAssessment(sessionId, userId, payload);
}

export const updateAssessmentData = async (sessionId: string, userId: string, tags: string[], data?: any, value?: any) => {
  const payload: UpdateAssessmentDataInput = {tags, data,};
  if (value) { payload.value = value; }

  return updateAssessment(sessionId, userId, payload);
}
